import { render, staticRenderFns } from "./SalesOrderNewPassengers.vue?vue&type=template&id=ab9a24f0&scoped=true"
import script from "./SalesOrderNewPassengers.vue?vue&type=script&lang=js"
export * from "./SalesOrderNewPassengers.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderNewPassengers.vue?vue&type=style&index=0&id=ab9a24f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9a24f0",
  null
  
)

export default component.exports